module.exports = __webpack_public_path__ + "img/dk.c29a080.svg";